// Tipos de cita: única fuente de verdad en el frontend.
//
// Los valores DEBEN coincidir con el enum de backend/src/models/Appointment.js
// (`type: enum ['video', 'chat', 'follow-up']`). Los selectores del panel de
// admin ofrecían 'in-person' y 'phone', que no existen en el modelo: guardar una
// cita como "Presencial" o "Telefónica" fallaba la validación de Mongoose.
//
// Se centraliza aquí porque el tipo se ofrece en dos modales y se pinta en tres
// pantallas más; con la lista repetida, arreglar un sitio dejaba los otros
// mostrando el slug crudo o proponiendo valores que el backend rechaza.

export const APPOINTMENT_TYPES = [
  { value: 'video',     label: 'Videollamada' },
  { value: 'chat',      label: 'Chat'         },
  { value: 'follow-up', label: 'Seguimiento'  },
];

export const DEFAULT_APPOINTMENT_TYPE = 'video';

const LABELS = Object.fromEntries(APPOINTMENT_TYPES.map((t) => [t.value, t.label]));

/**
 * Etiqueta legible de un tipo de cita.
 * Ante un valor desconocido devuelve el propio valor (o el fallback), en vez de
 * ocultarlo: si en la BD quedó un 'in-person' de antes, es mejor verlo.
 */
export const appointmentTypeLabel = (type, fallback = '—') =>
  LABELS[type] ?? (type || fallback);
